<template>
    <div class="main-content">
          <div class="toast-container position-fixed top-0 end-0 p-3" style="z-index: 1060">
            <transition-group name="slide-fade">
                <div v-for="alert in alerts" :key="alert.id"
                    class="toast show align-items-center border-0 shadow-lg mb-2"
                    :class="'bg-' + alert.type + '-subtle text-' + alert.type" role="alert">
                    <div class="d-flex p-3">
                        <i :class="alert.icon" class="me-3 fs-5"></i>
                        <div class="toast-body p-0 fw-medium">
                            {{ alert.message }}
                        </div>
                        <button type="button" class="btn-close ms-auto" @click="removeAlert(alert.id)"></button>
                    </div>
                </div>
            </transition-group>
        </div>
        <header class="content-header mb-2 mt-n5">
            <nav aria-label="breadcrumb">
                <ol class="breadcrumb mb-0">
                    <li class="breadcrumb-item"><router-link class="nav-link active" to="/">Início</router-link></li>
                    <li class="breadcrumb-item active text-dark small">Agenda</li>
                </ol>
            </nav>
        </header>

        <div class="card p-4 shadow-subtle rounded-4 border-0">
            <div class="d-flex justify-content-between align-items-center mb-4 pb-2 border-bottom">
                <div>
                    <h4 class="mb-0 fw-bold">Agenda e Eventos</h4>
                    <span class="text-muted fs-7">Controle de compromissos e prazos do sistema</span>
                </div>
                <div class="d-flex gap-2 align-items-center">

                    <button class="btn btn-pmg-light fw-bold text-dark" @click="goToToday" title="Ir para hoje">
                        Hoje
                    </button>

                    <select v-model="currentView" class="form-select form-control-pmg w-auto fw-medium bg-light border-0 shadow-sm cursor-pointer">
                        <option value="day">Visualizar Dia</option>
                        <option value="week">Visualizar Semana</option>
                        <option value="month">Visualizar Mês</option>
                        <option value="year">Visualizar Ano</option>
                    </select>

                    <button v-if="hasGoogleAuth" class="btn btn-pmg-light" @click="syncGoogleEvents" :disabled="isSyncing" title="Sincronizar com Google Agenda">
                        <span v-if="isSyncing" class="spinner-border spinner-border-sm me-1"></span>
                        <i v-else class="bi bi-arrow-repeat text-primary me-1"></i> Sincronizar
                    </button>

                    <button class="btn btn-pmg-light" @click="showFilter = !showFilter" :class="{ 'active': showFilter }">
                        <i class="bi bi-funnel"></i> Filtrar
                    </button>
                    <button class="btn btn-pmg-primary" @click="openModal('create')">
                        <i class="bi bi-calendar-plus me-1"></i> Novo Evento
                    </button>
                </div>
            </div>

            <div class="collapse" :class="{ 'show': showFilter }">
                <div class="card card-body mb-4 border-0 bg-light rounded-3">
                    <div class="row g-3 align-items-end">
                        <div class="col-md-5">
                            <label class="form-label text-muted small fw-bold mb-1">Buscar Evento</label>
                            <input v-model="filter.search" type="text" class="form-control form-control-pmg" placeholder="Título, descrição ou cliente...">
                        </div>
                        <div class="col-md-4">
                            <label class="form-label text-muted small fw-bold mb-1">Tipo de Evento</label>
                            <select v-model="filter.type" class="form-select form-control-pmg">
                                <option value="">Todos</option>
                                <option value="meeting">Reuniões</option>
                                <option value="payable">Contas a Pagar</option>
                                <option value="receivable">Contas a Receber</option>
                                <option value="quote_expiration">Vencimento de Orçamento</option>
                                <option value="consultation">Consulta</option>
                            </select>
                        </div>
                        <div class="col-md-3 d-flex gap-2">
                            <button class="btn btn-dark w-100 btn-pmg-dark fw-bold py-3" @click="fetchEvents">
                                <i class="bi bi-search"></i> Aplicar
                            </button>
                            <button class="btn btn-outline-danger py-1" @click="clearFilter" title="Limpar Filtros">
                                <i class="bi bi-x-lg"></i>
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <div class="card border-0 shadow-sm rounded-3 overflow-hidden bg-white mt-2">

                <div class="card-header bg-white border-bottom-0 pt-4 pb-2 d-flex justify-content-between align-items-center">
                    <button class="btn btn-outline-secondary btn-pmg-icon border" @click="navigate(-1)">
                        <i class="bi bi-chevron-left"></i>
                    </button>
                    <h5 class="fw-bold text-dark mb-0 text-capitalize">
                        {{ displayTitle }}
                    </h5>
                    <button class="btn btn-outline-secondary btn-pmg-icon border" @click="navigate(1)">
                        <i class="bi bi-chevron-right"></i>
                    </button>
                </div>

                <div class="card-body p-0">

                    <div v-if="currentView === 'day'" class="day-view-container border-top">
                        <!-- ADICIONADA A REF AQUI -->
                        <div class="timeline-scroll" ref="timelineContainer">
                            <!-- ADICIONADO O ID DINÂMICO AQUI -->
                            <div v-for="hour in 24" :key="'hour-'+(hour - 1)" class="hour-row d-flex border-bottom" :id="'hour-row-' + (hour - 1)">
                                <div class="hour-label text-muted small fw-bold p-3 border-end text-end" style="width: 80px; background: #f8fafc;">
                                    {{ String(hour - 1).padStart(2, '0') }}:00
                                </div>
                                <div class="hour-content flex-grow-1 p-2 position-relative cursor-pointer transition-hover-bg" 
                                     style="min-height: 70px; background: #fff;"
                                     @click.self="openModal('create', null, String(hour - 1).padStart(2, '0') + ':00')"
                                     title="Clique para adicionar um evento neste horário">

                                    <div v-for="event in getEventsForHour(currentDate, hour - 1)" :key="event.id" 
                                         class="event-card-day p-2 rounded-3 mb-1 shadow-sm border-start border-4 cursor-pointer"
                                         :class="getEventTypeClass(event.type)"
                                         @click.stop="openModal('show', event)">
                                        <div class="fw-bold small">
                                            <i :class="getEventTypeIcon(event.type)" class="me-1"></i> {{ event.title }}
                                            <i v-if="event.meet_link" class="bi bi-camera-video-fill ms-1 text-primary" title="Reunião Online"></i>
                                        </div>
                                        <div class="fs-8 opacity-75">{{ formatTimeFromDate(event.start_date) }}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div v-else-if="currentView === 'week'" class="calendar-wrapper week-view d-flex border-top">
                        <div v-for="dayObj in currentWeekDays" :key="dayObj.dateString" class="flex-fill border-end week-column">
                            <div class="text-center py-3 border-bottom bg-light cursor-pointer transition-hover" @click="goToSpecificDay(dayObj.date)">
                                <div class="small fw-bold text-muted text-uppercase mb-1">{{ dayObj.weekDayName }}</div>
                                <div class="fs-4 fw-bold" :class="dayObj.isToday ? 'text-primary' : 'text-dark'">
                                    <span :class="{'bg-primary text-white rounded-circle d-inline-block' : dayObj.isToday}" style="width: 40px; height: 40px; line-height: 40px;">
                                        {{ dayObj.dayNumber }}
                                    </span>
                                </div>
                            </div>
                            <div class="p-2" style="min-height: 400px;">
                                <div v-for="event in dayObj.events" :key="event.id" 
                                     class="event-badge text-truncate small mb-2 p-2 rounded-3 shadow-sm border-start border-4"
                                     :class="getEventTypeClass(event.type)"
                                     style="white-space: normal;"
                                     @click="openModal('show', event)">
                                    <div class="fw-bold mb-1">
                                        <i :class="getEventTypeIcon(event.type)" class="me-1"></i> {{ event.title }}
                                        <i v-if="event.meet_link" class="bi bi-camera-video-fill ms-1 text-primary"></i>
                                    </div>
                                    <div class="fs-7 opacity-75"><i class="bi bi-clock"></i> {{ formatTimeFromDate(event.start_date) }}</div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div v-else-if="currentView === 'month'" class="calendar-wrapper">
                       <div class="calendar-grid-header bg-light border-top border-bottom">
                            <div v-for="day in weekDays" :key="day" class="text-center py-2 small fw-bold text-muted border-end">
                                {{ day }}
                            </div>
                        </div>

                        <div class="calendar-grid">
                            <div v-for="blank in blankDays" :key="'blank-'+blank" class="calendar-day empty-day bg-light opacity-25"></div>

                            <div v-for="date in daysInMonth" :key="'day-'+date" 
                                 class="calendar-day" 
                                 :class="{'today-cell': isToday(date, currentDate.getMonth(), currentDate.getFullYear())}" 
                                 @click="goToDay(date)">

                                <div class="day-header d-flex justify-content-between mb-1">
                                    <span class="day-number" :class="{'bg-primary text-white shadow-sm': isToday(date, currentDate.getMonth(), currentDate.getFullYear())}">
                                        {{ date }}
                                    </span>
                                </div>

                                <div class="event-list-scroll">
                                    <div v-for="event in getEventsForDate(currentDate.getFullYear(), currentDate.getMonth(), date)" 
                                         :key="event.id" 
                                         class="event-badge-mini" 
                                         :class="getEventTypeClass(event.type)"
                                         @click.stop="openModal('show', event)">
                                        <i :class="getEventTypeIcon(event.type)" class="me-1 small"></i>
                                        <span class="event-title-text">{{ event.title }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div v-else-if="currentView === 'year'" class="year-view p-4 border-top">
                        <div class="row g-4">
                            <div v-for="(monthName, index) in monthsNames" :key="index" class="col-md-4 col-lg-3">
                                <div class="card h-100 border-0 shadow-sm rounded-4 cursor-pointer transition-hover" @click="goToMonth(index)">
                                    <div class="card-header bg-transparent border-bottom-0 pt-3 pb-0 text-center">
                                        <h6 class="fw-bold text-dark text-uppercase mb-0">{{ monthName }}</h6>
                                    </div>
                                    <div class="card-body text-center d-flex flex-column justify-content-center align-items-center">
                                        <span class="fs-1 fw-light text-muted opacity-25 mb-2">{{ index + 1 }}</span>
                                        <div class="badge bg-primary-subtle text-primary rounded-pill px-3 py-2 mt-2">
                                            {{ getEventsCountForMonth(index) }} Eventos
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal fade" id="modalEvent" tabindex="-1" aria-hidden="true">
             <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content border-0 shadow-lg rounded-4">
                    <div class="modal-header border-0 pt-4 px-4">
                        <h5 class="fw-bold m-0">{{ isViewing ? 'Detalhes do Evento' : (isEditing ? 'Editar Evento' : 'Novo Evento') }}</h5>
                        <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
                    </div>
                    <div class="modal-body px-4 pb-4">

                        <div v-if="formErrors.start_date" class="alert alert-danger py-2 mb-3 small border-0 shadow-sm rounded-3">
                            <i class="bi bi-exclamation-triangle-fill me-1"></i> {{ formErrors.start_date[0] }}
                        </div>

                        <div class="row g-3">
                            <div class="col-12">
                                <label class="form-label small fw-bold text-muted mb-1">Título <span v-if="!isViewing" class="text-danger">*</span></label>
                                <input v-model="form.title" :disabled="isViewing" type="text" class="form-control form-control-pmg" :class="{'is-invalid': formErrors.title}">
                                <div v-if="formErrors.title" class="invalid-feedback fw-medium">{{ formErrors.title[0] }}</div>
                            </div>

                            <div class="col-md-6">
                                <label class="form-label small fw-bold text-muted mb-1">Data</label>
                                <input v-model="form.date" :disabled="isViewing" type="date" class="form-control form-control-pmg">
                            </div>

                            <div class="col-md-6">
                                <label class="form-label small fw-bold text-muted mb-1">Horário</label>
                                <input v-model="form.time" :disabled="isViewing" type="time" class="form-control form-control-pmg">
                            </div>

                            <div class="col-12">
                                <label class="form-label small fw-bold text-muted mb-1">Tipo de Evento</label>
                                <select v-model="form.type" :disabled="isViewing" class="form-select form-control-pmg" :class="{'is-invalid': formErrors.type}">
                                    <option value="meeting">Reunião</option>
                                    <option value="payable">Conta a Pagar</option>
                                    <option value="receivable">Conta a Receber</option>
                                    <option value="quote_expiration">Vencimento de Orçamento</option>
                                     <option value="consultation">Consulta</option>
                                </select>
                                <div v-if="formErrors.type" class="invalid-feedback fw-medium">{{ formErrors.type[0] }}</div>
                            </div>

                            <div v-if="form.type === 'meeting'" class="col-12 mt-2">
                                <div class="p-3 bg-light rounded-3 border">

                                    <div v-if="!isViewing && !form.meet_link">
                                        <div class="form-check form-switch pmg-switch d-flex align-items-center mb-0">
                                            <input class="form-check-input cursor-pointer me-2" type="checkbox" id="generateMeet" v-model="form.generate_meet_link" style="width: 40px; height: 20px;">
                                            <label class="form-check-label fw-bold text-dark cursor-pointer m-0" for="generateMeet">
                                                <i class="bi bi-camera-video-fill text-primary me-1"></i> Gerar link do Google Meet?
                                            </label>
                                        </div>
                                    </div>

                                    <div v-if="form.meet_link">
                                        <label class="form-label small fw-bold text-muted mb-1">Link da Reunião Gerado</label>
                                        <div class="d-flex align-items-center">
                                            <a :href="form.meet_link" target="_blank" class="text-primary fw-medium text-decoration-none text-truncate me-auto">
                                                <i class="bi bi-link-45deg fs-5"></i> {{ form.meet_link }}
                                            </a>
                                            <button class="btn btn-sm btn-outline-secondary py-1 ms-2" @click="copyMeetLink" title="Copiar Link">
                                                <i class="bi bi-clipboard"></i>
                                            </button>
                                        </div>
                                    </div>
                                    <div v-else-if="isViewing" class="text-muted small">
                                        Nenhum link do Google Meet associado.
                                    </div>
                                </div>
                            </div>

                            <div class="col-12 mt-3 pb-2">
                                <label class="form-label small fw-bold text-muted mb-1">Descrição / Observações</label>
                                <textarea v-model="form.description" :disabled="isViewing" class="form-control form-control-pmg" rows="3"></textarea>
                            </div>
                        </div>
                    </div>

                    <div class="modal-footer border-0 pb-4 px-4 d-flex justify-content-between">
                        <div>
                            <button v-if="form.id" class="btn btn-outline-danger" @click="confirmDelete" :disabled="loading">
                                <i class="bi bi-trash3 me-1"></i> Excluir
                            </button>
                        </div>
                        <div>
                            <button class="btn btn-pmg-light me-2" data-bs-dismiss="modal">Fechar</button>

                            <button v-if="isViewing" class="btn btn-pmg-primary px-4" @click="enableEditMode">
                                <i class="bi bi-pencil-square me-1"></i> Editar
                            </button>

                            <button v-if="!isViewing" class="btn btn-pmg-primary px-4" @click="handleSaveAttempt" :disabled="loading">
                                <span v-if="loading" class="spinner-border spinner-border-sm me-1"></span>
                                <span v-if="form.generate_meet_link && !hasGoogleAuth && !form.meet_link">
                                    <i class="bi bi-google me-1"></i> Conectar e Gerar Link
                                </span>
                                <span v-else>{{ isEditing ? 'Atualizar' : 'Salvar Evento' }}</span>
                            </button>
                        </div>
                    </div>

                </div>
            </div>
        </div>

        <div class="modal fade" id="confirmDeleteModal" tabindex="-1" aria-hidden="true">
            <div class="modal-dialog modal-sm modal-dialog-centered">
                <div class="modal-content border-0 shadow-lg rounded-4 text-center p-3">
                    <div class="modal-body">
                        <div class="text-danger mb-3">
                            <i class="bi bi-exclamation-triangle-fill fs-1"></i>
                        </div>
                        <h5 class="fw-bold">Tem certeza?</h5>
                        <p class="text-muted small">Excluir "{{ form.title }}"?</p>
                    </div>
                    <div class="d-flex gap-2 justify-content-center pb-2">
                        <button class="btn btn-pmg-light px-4" @click="cancelDeletion">Cancelar</button>
                        <button class="btn btn-danger px-4 rounded-3" @click="executeDeletion" :disabled="loading">
                            <span v-if="loading" class="spinner-border spinner-border-sm me-1"></span>
                            Confirmar
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal fade" id="modalGoogleAuth" tabindex="-1" aria-hidden="true" data-bs-backdrop="static">
             <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content border-0 shadow-lg rounded-4 text-center p-4">
                    <div class="modal-body">
                        <div class="mb-4">
                            <div class="d-inline-flex align-items-center justify-content-center bg-light rounded-circle mb-3" style="width: 80px; height: 80px;">
                                <i class="bi bi-google text-danger fs-1"></i>
                            </div>
                            <h4 class="fw-bold text-dark">Integração Necessária</h4>
                            <p class="text-muted mb-0">Para gerar links do Meet automaticamente, o <strong>Dailypag</strong> precisa de permissão para acessar sua agenda Google.</p>
                        </div>

                        <div class="d-grid gap-2">
                            <button class="btn btn-dark fw-bold py-3 rounded-3 d-flex align-items-center justify-content-center gap-2" @click="authenticateGoogle" :disabled="isAuthenticating">
                                <span v-if="isAuthenticating" class="spinner-border spinner-border-sm"></span>
                                <i v-else class="bi bi-google"></i> Autorizar com Google
                            </button>
                            <button class="btn btn-light text-muted mt-2" @click="cancelGoogleAuth">Cancelar</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import api from '@/services/api';

export default {
    data() {
        return {
            alerts: [], 
            loading: false,
            isSyncing: false,
            currentView: 'day',
            currentDate: new Date(),
            showFilter: false,
            isEditing: false,
            isViewing: false,
            
            modalEventInstance: null,
            modalGoogleAuthInstance: null,
            modalConfirmDeleteInstance: null,
            
            hasGoogleAuth: false, 
            isAuthenticating: false,

            events: [],
            weekDays: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb'],
            monthsNames: ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'],
            
            form: { id: null, title: '', date: '', time: '', type: 'meeting', description: '', generate_meet_link: false, meet_link: '', status: 'pending' },
            formErrors: {}, 
            filter: { search: '', type: '' }
        }
    },

    computed: {
        displayTitle() {
            const year = this.currentDate.getFullYear();
            const month = this.currentDate.getMonth();
            const date = this.currentDate.getDate();

            if (this.currentView === 'year') return `${year}`;
            if (this.currentView === 'month') return `${this.monthsNames[month]} ${year}`;
            if (this.currentView === 'day') return `${date} de ${this.monthsNames[month]} de ${year}`;
            
            if (this.currentView === 'week') {
                const firstDay = new Date(this.currentDate);
                firstDay.setDate(date - this.currentDate.getDay());
                const lastDay = new Date(firstDay);
                lastDay.setDate(firstDay.getDate() + 6);
                return `${firstDay.getDate()} ${this.monthsNames[firstDay.getMonth()]} - ${lastDay.getDate()} ${this.monthsNames[lastDay.getMonth()]} de ${year}`;
            }
            return '';
        },
        daysInMonth() {
            return new Date(this.currentDate.getFullYear(), this.currentDate.getMonth() + 1, 0).getDate();
        },
        blankDays() {
            return new Date(this.currentDate.getFullYear(), this.currentDate.getMonth(), 1).getDay();
        },
        currentWeekDays() {
            const days = [];
            const startOfWeek = new Date(this.currentDate);
            startOfWeek.setDate(this.currentDate.getDate() - this.currentDate.getDay());
            for (let i = 0; i < 7; i++) {
                const dayDate = new Date(startOfWeek);
                dayDate.setDate(startOfWeek.getDate() + i);
                days.push({
                    date: dayDate,
                    dateString: this.formatDateObjToString(dayDate),
                    dayNumber: dayDate.getDate(),
                    weekDayName: this.weekDays[i],
                    isToday: this.isToday(dayDate.getDate(), dayDate.getMonth(), dayDate.getFullYear()),
                    events: this.getEventsForSpecificDate(dayDate)
                });
            }
            return days;
        }
    },

    watch: {
        currentView() {
            this.scrollToCurrentTime();
        },
        currentDate() {
            this.scrollToCurrentTime();
        }
    },

    methods: {
        scrollToCurrentTime() {
            this.$nextTick(() => {
                if (this.currentView !== 'day') return;
                
                if (!this.isToday(this.currentDate.getDate(), this.currentDate.getMonth(), this.currentDate.getFullYear())) return;

                const currentHour = new Date().getHours();
                const targetHour = Math.max(0, currentHour - 1); 
                
                const container = this.$refs.timelineContainer;
                const targetElement = document.getElementById(`hour-row-${targetHour}`);

                if (container && targetElement) {
                    container.scrollTo({
                        top: targetElement.offsetTop,
                        behavior: 'smooth'
                    });
                }
            });
        },

        showAlert(message, type = 'success') {
            if (!this.alerts) this.alerts = [];
            
            const id = Date.now(); // Cria um ID único para cada alerta
            this.alerts.push({ id, message, type });
            
            setTimeout(() => {
                this.removeAlert(id);
            }, 3000);
        },
        
        removeAlert(id) {
            this.alerts = this.alerts.filter(a => a.id !== id);
        },

        formatTimeFromDate(datetimeString) {
            if (!datetimeString) return 'O Dia Todo';
            const dateObj = new Date(datetimeString);
            return `${String(dateObj.getHours()).padStart(2, '0')}:${String(dateObj.getMinutes()).padStart(2, '0')}`;
        },

        getEventsForHour(dateObj, hour) {
            const dateStr = this.formatDateObjToString(dateObj);
            return this.events.filter(e => {
                if (!e.start_date) return false;
                const eDateObj = new Date(e.start_date);
                const eDateStr = this.formatDateObjToString(eDateObj);
                const eventHour = eDateObj.getHours();
                
                return eDateStr === dateStr && eventHour === hour;
            });
        },

        getEventsForDate(year, month, date) {
            const dateStr = `${year}-${String(month + 1).padStart(2, '0')}-${String(date).padStart(2, '0')}`;
            return this.events.filter(e => {
                 if (!e.start_date) return false;
                 return this.formatDateObjToString(new Date(e.start_date)) === dateStr;
            });
        },

        getEventsForSpecificDate(dateObj) {
            return this.getEventsForDate(dateObj.getFullYear(), dateObj.getMonth(), dateObj.getDate());
        },

        getEventsCountForMonth(monthIndex) {
            const mString = String(monthIndex + 1).padStart(2, '0');
            return this.events.filter(e => {
                 if (!e.start_date) return false;
                 return this.formatDateObjToString(new Date(e.start_date)).split('-')[1] === mString;
            }).length;
        },

        goToToday() {
            this.currentDate = new Date();
            this.fetchEvents();
            this.scrollToCurrentTime();
        },

        navigate(step) {
            const newDate = new Date(this.currentDate);
            if (this.currentView === 'year') newDate.setFullYear(newDate.getFullYear() + step);
            else if (this.currentView === 'month') newDate.setMonth(newDate.getMonth() + step);
            else if (this.currentView === 'week') newDate.setDate(newDate.getDate() + (step * 7));
            else if (this.currentView === 'day') newDate.setDate(newDate.getDate() + step);
            this.currentDate = newDate;
            this.fetchEvents();
        },

        goToMonth(index) { this.currentDate.setMonth(index); this.currentView = 'month'; },
        goToDay(date) { this.currentDate.setDate(date); this.currentView = 'day'; },
        goToSpecificDay(date) { this.currentDate = new Date(date); this.currentView = 'day'; },

        formatDateObjToString(dateObj) {
            const y = dateObj.getFullYear();
            const m = String(dateObj.getMonth() + 1).padStart(2, '0');
            const d = String(dateObj.getDate()).padStart(2, '0');
            return `${y}-${m}-${d}`;
        },

        isToday(d, m, y) {
            const now = new Date();
            return d === now.getDate() && m === now.getMonth() && y === now.getFullYear();
        },

        getEventTypeClass(type) {
            const map = { meeting: 'bg-primary-subtle text-primary border-primary-subtle', payable: 'bg-danger-subtle text-danger border-danger-subtle', receivable: 'bg-success-subtle text-success border-success-subtle', quote_expiration: 'bg-warning-subtle text-warning border-warning-subtle' };
            return map[type] || 'bg-light text-dark';
        },

        getEventTypeIcon(type) {
            const map = { meeting: 'bi-people-fill', payable: 'bi-arrow-down-circle-fill', receivable: 'bi-arrow-up-circle-fill', quote_expiration: 'bi-clock-history' };
            return map[type] || 'bi-calendar-event';
        },

        openModal(mode, item = null, defaultTime = '08:00') {
            this.isViewing = mode === 'show';
            this.isEditing = mode === 'edit';
            this.formErrors = {}; 
            
            if (item) {
                let datePart = '';
                let timePart = '';
                if (item.start_date) {
                    const dt = new Date(item.start_date);
                    datePart = this.formatDateObjToString(dt);
                    timePart = `${String(dt.getHours()).padStart(2, '0')}:${String(dt.getMinutes()).padStart(2, '0')}`;
                }
                
                this.form = { 
                    ...item, 
                    date: datePart,
                    time: timePart,
                    generate_meet_link: false
                };
            } else {
                this.form = { id: null, title: '', date: this.formatDateObjToString(this.currentDate), time: defaultTime, type: 'meeting', description: '', generate_meet_link: false, meet_link: '', status: 'pending' };
            }
            if (this.modalEventInstance) this.modalEventInstance.show();
        },

        enableEditMode() {
            this.isViewing = false;
            this.isEditing = true;
        },

        async handleSaveAttempt() {
            if (this.form.type === 'meeting' && this.form.generate_meet_link && !this.hasGoogleAuth && !this.form.meet_link) {
                this.modalEventInstance.hide();
                this.modalGoogleAuthInstance.show();
                return;
            }
            await this.executeSaveEvent();
        },

        async authenticateGoogle() {
            this.isAuthenticating = true;
            try {
                const response = await api.get('/auth/google/url');
                const width = 500, height = 600;
                const left = window.screen.width / 2 - width / 2;
                const top = window.screen.height / 2 - height / 2;
                window.open(response.data.url, 'Google Auth', `width=${width},height=${height},top=${top},left=${left}`);
            } catch (error) {
                console.error("Erro OAuth", error);
                this.isAuthenticating = false;
            }
        },

        handleGoogleCallback(event) {
            if (event.data && event.data.type === 'GOOGLE_AUTH_SUCCESS') {
                this.hasGoogleAuth = true;
                this.isAuthenticating = false;
                this.modalGoogleAuthInstance.hide();
                this.modalEventInstance.show();
            }
        },

        async executeSaveEvent() {
            this.loading = true;
            this.formErrors = {}; 

            try {
                const payload = {
                    title: this.form.title,
                    type: this.form.type,
                    description: this.form.description,
                    status: this.form.status || 'pending',
                    start_date: (this.form.date && this.form.time) ? `${this.form.date} ${this.form.time}:00` : '',
                    generate_meet_link: this.form.generate_meet_link
                };

                let response;
                if (this.form.id) {
                    response = await api.put(`/events/${this.form.id}`, payload);
                } else {
                    response = await api.post('/events', payload);
                }
                
                if (response.data.data && response.data.data.meet_link) {
                    this.form.meet_link = response.data.data.meet_link;
                    this.showAlert("Link do Google Meet gerado com sucesso!", "success");
                } else {
                    this.showAlert("Evento salvo com sucesso!", "success");
                    this.modalEventInstance.hide();
                }
                this.fetchEvents(); 
            } catch (error) {
                if(error.response && error.response.status === 422) {
                    this.formErrors = error.response.data.errors;
                } else {
                    console.error('Erro inesperado ao salvar', error);
                    this.showAlert("Ocorreu um erro no servidor. Tente novamente.", "danger");
                }
            } finally {
                this.loading = false;
            }
        },

        confirmDelete() {
            if (this.modalEventInstance) this.modalEventInstance.hide();
            if (this.modalConfirmDeleteInstance) this.modalConfirmDeleteInstance.show();
        },

        cancelDeletion() {
            if (this.modalConfirmDeleteInstance) this.modalConfirmDeleteInstance.hide();
            if (this.modalEventInstance) this.modalEventInstance.show();
        },

        async executeDeletion() {
            this.loading = true;
            
            try {
                await api.delete(`/events/${this.form.id}`);
                
                this.showAlert('Evento excluído com sucesso!', 'success');

                this.modalConfirmDeleteInstance.hide();
                this.fetchEvents();
                
            } catch (error) {
                console.error('Erro ao excluir o evento:', error);
                this.showAlert('Ocorreu um erro ao tentar excluir o evento.');
            } finally {
                this.loading = false;
            }
        },

        copyMeetLink() {
            if(this.form.meet_link) {
                navigator.clipboard.writeText(this.form.meet_link);
                this.showAlert('Link copiado!', 'success');
            }
        },

        cancelGoogleAuth() {
            this.modalGoogleAuthInstance.hide();
            this.modalEventInstance.show();
        },

        async syncGoogleEvents() {
            this.isSyncing = true;
            
            try {
                const response = await api.post('/events/sync');
                this.showAlert(response.data.message, 'success');
                this.fetchEvents();
            } catch (error) {
                console.error('Erro ao sincronizar com Google:', error);
                const errorMessage = error.response?.data?.message || 'Falha ao sincronizar com o Google.';
                this.showAlert(errorMessage, 'danger');
            } finally {
                this.isSyncing = false;
            }
        },

        // NOVO: Método para sincronização em background (Silent Sync)
        async silentSync() {
            this.isSyncing = true; 
            
            try {
                await api.post('/events/sync');
                await this.fetchEvents(); 
            } catch (error) {
                console.error('Auto-sync silencioso falhou:', error);
            } finally {
                this.isSyncing = false;
            }
        },

        clearFilter() { this.filter = { search: '', type: '' }; this.fetchEvents(); },

        async fetchEvents() {
            this.loading = true;
            try {
                let start, end;
                const y = this.currentDate.getFullYear();
                const m = String(this.currentDate.getMonth() + 1).padStart(2, '0');

                if (this.currentView === 'year') {
                    start = `${y}-01-01`;
                    end = `${y}-12-31`;
                } else {
                    const lastDay = new Date(y, this.currentDate.getMonth() + 1, 0).getDate();
                    start = `${y}-${m}-01`;
                    end = `${y}-${m}-${String(lastDay).padStart(2, '0')}`;
                }

                const params = {
                    start: start,
                    end: end,
                    ...this.filter
                };

                const response = await api.get('/events', { params });
                this.events = response.data.data || [];
                
            } catch (error) {
                console.error('Erro ao buscar eventos', error);
            } finally { 
                this.loading = false; 
            }
        }
    },

    mounted() {
        const elEvent = document.getElementById('modalEvent');
        if (elEvent) {
            this.modalEventInstance = new window.bootstrap.Modal(elEvent);
        }

        const elGoogleAuth = document.getElementById('modalGoogleAuth');
        if (elGoogleAuth) {
            this.modalGoogleAuthInstance = new window.bootstrap.Modal(elGoogleAuth);
        }

        const elConfirmDelete = document.getElementById('confirmDeleteModal');
        if (elConfirmDelete) {
            this.modalConfirmDeleteInstance = new window.bootstrap.Modal(elConfirmDelete);
        }

        window.addEventListener('message', this.handleGoogleCallback);
        
        // 1. Primeiro carrega o banco local para a tela abrir rápido
        this.fetchEvents().then(() => {
            this.scrollToCurrentTime();
        });

        // 2. Verifica o Google. Se estiver logado, dispara a sincronização silenciosa
        api.get('/auth/google/check')
           .then(res => {
               this.hasGoogleAuth = res.data.connected;
               
               if (this.hasGoogleAuth) {
                   this.silentSync(); // <-- A CHAMADA QUE FALTAVA
               }
           })
           .catch(() => { 
               this.hasGoogleAuth = false; 
           });
    },

    beforeUnmount() {
        window.removeEventListener('message', this.handleGoogleCallback);
    }
}
</script>

<style scoped>
.main-content { background-color: #f8fafc; min-height: 100vh; padding: 2rem; font-family: 'Inter', sans-serif; }
.card { border-radius: 16px; box-shadow: 0 10px 30px rgba(0, 0, 0, 0.02); }
.btn-pmg-primary { background: #561569; color: #fff; border: none; border-radius: 10px; padding: 10px 20px; font-weight: 500; }
.btn-pmg-light { background: #fff; border: 1px solid #e2e8f0; border-radius: 10px; color: #64748b; padding: 10px 20px; font-weight: 500;}
.form-control-pmg { border-radius: 10px; border: 1px solid #e2e8f0; padding: 12px; transition: all 0.2s; }
.form-control-pmg:focus { border-color: #561569; box-shadow: 0 0 0 4px rgba(33, 51, 97, 0.1); }
.btn-pmg-icon { width: 38px; height: 38px; display: inline-flex; align-items: center; justify-content: center; border-radius: 8px; transition: all 0.2s; }
.cursor-pointer { cursor: pointer; }
.transition-hover-bg:hover { background: #fbfcfd !important; }
.timeline-scroll { max-height: 700px; overflow-y: auto; scroll-behavior: smooth; }
.hour-label { font-size: 0.75rem; }
.calendar-grid { display: grid; grid-template-columns: repeat(7, 1fr); border-left: 1px solid #e9ecef; }
.calendar-day { min-height: 120px; border-right: 1px solid #e9ecef; border-bottom: 1px solid #e9ecef; padding: 8px; background-color: #fff; transition: background-color 0.2s; cursor: pointer; }
.calendar-day:hover { background-color: #f8fafc; }
.pmg-switch .form-check-input:checked { background-color: #561569; border-color: #561569; }
.fs-8 { font-size: 0.75rem; }

.calendar-grid-header, 
.calendar-grid {
    display: grid;
    grid-template-columns: repeat(7, 1fr); 
}

.calendar-grid {
    background-color: #e2e8f0; 
    gap: 1px; 
    border-bottom: 1px solid #e2e8f0;
}

.calendar-day {
    min-height: 120px; 
    background-color: #fff;
    padding: 8px;
    display: flex;
    flex-direction: column;
}

.event-list-scroll {
    flex-grow: 1;
    overflow-y: auto;
    max-height: 85px; 
}

.event-badge-mini {
    font-size: 0.7rem;
    padding: 2px 4px;
    margin-bottom: 2px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis; 
    border-radius: 3px;
    border-left: 3px solid;
}

.day-number {
    font-weight: 600;
    width: 24px;
    height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
}
</style>